<template>
    <template v-if="!showTranscribe">
        <div class="group_score_zero" v-if="ceilingGroup">
            <img :src="zeroPoint" />
            <h4>Group {{ groupId }} is not given: five consecutive 0 scores in Group {{ ceilingGroup }} reached the
                ceiling, so the test stopped there. {{ ceilingScopeText(ceilingGroup) }}
                ({{ CEILING_RULE_REF }})</h4>
            <a class="group_score_zero__btn" href="javascript:void(0)" @click="handleNavigate('next')"
                v-if="groupId != 5">Access
                Group {{ groupId + 1 }}</a>
            <a class="group_score_zero__btn" href="javascript:void(0)" @click="handleNavigate('next')"
                v-if="groupId == 5">Access
                Result</a>
        </div>
        <template v-else>
            <!-- Group Header -->
            <div class="assetssment__head__section rlms-height-auto">
                <div class="section__title__box">
                    <div class="rlms-flex rlms-items-center">
                        <h4 class="title">{{ currentGroup.title }}</h4>

                        <div class="video__info__btn__item transcription-setting">
                            <a href="javascript:void(0)" class="rlms-flex rlms-items-center" @click="showVideoTutorial = true">
                                <span class="badge rlms-fw-600 rlms-flex rlms-items-center rlms-gap-5"><span class="material-symbols-outlined">help</span> Help</span>
                            </a>
                        </div>
                    </div>
                    <div class="small__note__title">
                        <label>Targets :</label>
                        <span>{{ currentGroup.target }}</span>
                    </div>
                </div>

                <!-- Scoring Legend -->
                <div class="assetssment__data__box rlms-height-auto">
                    <div class="heading__box">
                        <div class="heading__item">Scoring</div>
                        <div class="heading__item">1 Point</div>
                        <div class="heading__item" v-if="currentGroup.id <= 3">1/2 Point</div>
                        <div class="heading__item">0 Points</div>
                    </div>
                    <div class="divider__sepline"></div>
                    <div class="data__table__box">
                        <div class="row__box" v-for="(row, index) in currentGroup.scoringLegend" :key="index">
                            <div class="data__item">{{ row.category }}</div>
                            <div class="data__item">{{ row.full }}</div>
                            <div class="data__item" v-if="row.half">{{ row.half }}</div>
                            <div class="data__item">{{ row.zero }}</div>
                        </div>
                    </div>
                    <p class="note-text rlms-fs-xxs rlms-text-secondary-base rlms-mt-2">
                        {{ scoringRuleNote(currentGroup.id) }} ({{ SCORING_RULE_REF }})
                    </p>
                    <p class="note-text rlms-fs-xxs rlms-text-secondary-base rlms-mt-2">
                        {{ CEILING_RULE_NOTE }}
                    </p>
                </div>
            </div>

            <!-- Metadata about current group -->
            <div class="showing__data__head">
                <h6 class="label">Showing Results for Group {{ currentGroup.id }}</h6>
                <span>{{ groupItemsText }}</span>
            </div>

            <!-- Group Content and State Display -->
            <div class="assetssment__content__block">
                <!-- Conditional message when no data selected or skipped -->
                <div class="assetssment__no__data__block datanotfound" v-if="!isGroupSelected">
                    <template v-if="isSkippedGroup">
                        <div class="assetssment__no__data__img">
                            <img :src="skippedGrp" />
                        </div>
                        <div class="assetssment__data__text__box">
                            <h6 class="title">You have skipped this section full marks given*</h6>
                            <p>You have stated that your learner can complete group 1 so you will not be able to test
                                ....
                            </p>
                        </div>
                        <div class="assetssment__btn__box">
                            <div class="purple__regular__btn">
                                <a href="javascript:void(0)" @click="handleNavigate('next')">{{ assessment?.skip_group2
                                    ? `Access
                                    Group
                                    ${currentGroup.id +
                                    1}`
                                    : 'Access Group 2' }}</a>
                            </div>
                        </div>
                    </template>
                    <template v-else>
                        <div class="assetssment__no__data__img">
                            <img :src="notFoundImg" alt="No data" />
                        </div>

                        <template v-if="canConductAssessment && assessment?.is_latest">
                            <div class="assetssment__data__text__box">
                                <h6 class="title">To Begin, Select your test items</h6>
                                <p>{{ selectionInstructions }}</p>
                            </div>
                            <div class="assetssment__btn__box">
                                <div class="purple__regular__btn">
                                    <a href="javascript:void(0)" @click="showSelectItemModel = true">Select Items</a>
                                </div>
                            </div>
                        </template>
                        <template v-else>
                            <div class="assetssment__data__text__box">
                                <h6 class="title">No Item Selected.</h6>
                            </div>
                        </template>
                    </template>
                </div>

                <!-- Display data table if items selected -->
                <div class="assetssment__data__table__wrapper datafound" v-if="isGroupSelected">
                    <div class="assetssment__table__head">
                        <div class="no table__head__item">No</div>
                        <div class="test__item table__head__item">Test Item</div>
                        <div class="score__assessment table__head__item">Score Assessment</div>
                        <div class="action table__head__item info__popup__wrap">Action</div>
                        <div class="video__info__btn__item" v-if="false">
                            <a href="javascript:void(0)" @click="showVideoTutorial = true" v-if="false">
                                <span class="btn__icon"><img :src="videoInfoIcon"></span>
                                <span class="btn__text">Video info</span>
                            </a>
                        </div>
                    </div>
                    <div class="divider__sepline"></div>

                    <!-- Render each assessment item -->
                    <div class="assetssment__data__box__wrapper">
                        <AssessmentItem v-for="(item, index) in resultItems" :key="item.id" :item="item"
                            :index="index + 1" :assessmentId="assessmentId" :organizationId="organizationId"
                            :group="currentGroup" @scored="updateAttempt" @flagged="updateAttempt"
                            @savedAudio="updateAudio" @recordAudio="handleRecordAudio" @transcribe="openTranscribe"
                            :canConductAssessment="canConductAssessment" :assessment="assessment" />
                    </div>

                    <!-- Navigation between groups -->
                    <div class="table__control__box">
                        <div class="prev__btn" v-if="groupId !== 1">
                            <a href="javascript:void(0)" @click="handleNavigate('prev')">
                                <span class="btn__icon"><img :src="arrowRight"></span>
                                <span class="btn__text">Prev</span>
                            </a>
                        </div>
                        <div class="next__btn">
                            <a href="javascript:void(0)" @click="handleNavigate('next')">
                                <span class="btn__text">Next</span>
                                <span class="btn__icon"><img :src="whiteArrowDown"></span>
                            </a>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Modals for item selection and audio recorder -->
            <SelectItemsModal v-if="showSelectItemModel" :questions="questions" :group="currentGroup"
                :organizationId="organizationId" :assessmentId="assessmentId" @close="showSelectItemModel = false"
                @saved="emit('updated'); showSelectItemModel = false" />

            <template v-if="!canConductAssessment">
                <PlayAudioModal v-if="selectedAssessmentItem" :item="selectedAssessmentItem"
                    @close="selectedAssessmentItem = null" />
            </template>
            <template v-else>
                <AssessmentAudioRecorder v-if="selectedAssessmentItem" :item="selectedAssessmentItem"
                    :assessmentId="assessmentId" :organizationId="organizationId"
                    :canConductAssessment="canConductAssessment" :assessment="assessment" :group="currentGroup"
                    :agreement="agreement"
                    @scored="updateAttempt" @close="selectedAssessmentItem = null" @saved="updateAudio"
                    @goto="handleAudioNav"
                    @feedback="updateFeedback" />
            </template>
            <VideoGuideModel v-if="showVideoTutorial" :groupId="currentGroup.id" @close="showVideoTutorial = false" />
        </template>
    </template>

    <template v-else>
        <AssessmentTranscribe :item="selectedAssessmentItem" :assessmentId="assessmentId"
            :organizationId="organizationId" :canConductAssessment="canConductAssessment" :assessment="assessment"
            @close="closeTranscribe" @saved="emit('updated')" @navigate="handleNextPrevTranscribe" />
    </template>
</template>
<script setup>
import { ref, computed, onMounted, watch } from 'vue';
import api from '@/services/axios';
import { useLoaderStore } from '@/stores/loader';
import { getGroupById } from '@/utils/assessmentGroups';
import { showDialog } from '@/utils/swal';
// import { formatConsonants } from '@/utils/format-helpers';
import Icon from '@/assets/images/cantmark.png';
import SelectItemsModal from './SelectItemsModal.vue';
import AssessmentItem from './AssessmentItem.vue';
import AssessmentAudioRecorder from './AssessmentAudioRecorder.vue';
import AssessmentTranscribe from './AssessmentTranscribe.vue';
import VideoGuideModel from './VideoGuideModel.vue';
import { handleError } from '@/utils/handleError';
import skippedGrp from '@/assets/images/skipped_grp.png';
import zeroPoint from '@/assets/images/zero-point.png';
import notFoundImg from '@/assets/images/not-found-img.png';
import videoInfoIcon from '@/assets/images/video-info-icon.png';
import arrowRight from '@/assets/images/arrow-right.png';
import whiteArrowDown from '@/assets/images/white-arrow-down.png';
import PlayAudioModal from '../PlayAudioModal.vue';
import { pollAttemptApiUntilComplete } from '@/utils/pollApi';
import { scoringRuleNote, SCORING_RULE_REF } from '@/utils/assessment-notes';
import {
    blockingCeilingGroup,
    ceilingScopeText,
    longestZeroRun,
    CEILING_RULE_NOTE,
    CEILING_RULE_REF,
} from '@/utils/assessment-ceiling';

// Emits from parent component
const emit = defineEmits(['updated', 'next-group', 'prev-group', 'update-flagged-count', 'update-zero-count']);

// Props
const props = defineProps({
    groupId: Number,
    organizationId: Number,
    assessmentId: Number,
    assessment: Object,
    canConductAssessment: Boolean,
    agreement: {
        type: Object,
        default: null
    },
});

// State variables
const questions = ref([]);
const showSelectItemModel = ref(false);
const showTranscribe = ref(false);
const showVideoTutorial = ref(false);
const selectedAssessmentItem = ref(null);
const lastUpdatedAttemptId = ref(null);

// Derived Computed Values
const loader = useLoaderStore();

const currentGroup = computed(() => getGroupById(props.groupId));

const groupItemsText = computed(() => `Select ${currentGroup.value?.selectionCount || 0} items`);

const selectionInstructions = computed(() => {
    const { totalCount = 0, selectionCount = 0 } = currentGroup.value;
    return `Deselect ${totalCount - selectionCount} of these ${totalCount} items.`;
});

const isSkippedGroup = computed(() => {
    const groupId = currentGroup.value?.id;
    return (groupId === 1 && props.assessment?.skip_group1) ||
        (groupId === 2 && props.assessment?.skip_group2);
});

const isGroupSelected = computed(() => {
    return !!props.assessment?.[`group${currentGroup.value?.id}`];
});

// The group an earlier ceiling closed this one from, or null. Only a Group 1 or
// Group 2 ceiling carries forward: after a Group 3 ceiling, Groups 4 and 5 are
// still given.
const ceilingGroup = computed(() =>
    blockingCeilingGroup(currentGroup.value?.id, props.assessment?.result?.items || {})
);

const resultItems = computed(() => props.assessment?.result?.items?.[`${currentGroup.value?.id}`] || []);

// Five IN A ROW, not five in total.
const zeroScoreCount = computed(() => longestZeroRun(resultItems.value));

const flaggedCount = computed(() => {
    return resultItems.value.filter(item => item.flagged == 1).length;
});

// API Call to fetch available questions
const fetchQuestions = async () => {
    try {
        loader.show();
        const { data } = await api.get(`/questions/${props.groupId}`);
        questions.value = data.data;
    } catch (error) {
        handleError(error);
    } finally {
        loader.hide();
    }
};

// Update attempt data (score or flag)
const updateFeedback = async ({attemptId, feedback}) => {
    const index = resultItems.value.findIndex(i => i.attemptid === attemptId);
    if (index === -1) return;

    resultItems.value[index].feedback = feedback;
};

const updateAttempt = async ({ type, id, value = null }) => {
    const index = resultItems.value.findIndex(i => i.attemptid === id);
    if (index === -1) return;

    const radios = document.querySelectorAll(`input[type="radio"][id^="point_${id}_"]`);
    const resetRadios = () => radios.forEach(radio => (radio.checked = false));

    const radios2 = document.querySelectorAll(`input[type="radio"][id^="audio_point_${id}_"]`);
    const resetRadios2 = () => radios2.forEach(radio => (radio.checked = false));

    const item = resultItems.value[index];
    const payload = { attemptid: id };

    try {
        loader.show();

        // Sequential scoring validation
        if (index > 0) {
            const prevIncomplete = resultItems.value
                .slice(0, index)
                .some(item => (item.score === undefined || item.score === null) && !item.flagged);

            if (prevIncomplete) {
                item[type] = null;
                resetRadios();
                resetRadios2();
                payload[type] = item[type];
                const { data } = await api.post(`/organizations/${props.organizationId}/assessments/${props.assessmentId}/attempt`, payload);
                item[type] = data.data[type];

                if (selectedAssessmentItem.value) {
                    selectedAssessmentItem.value[type] = data.data[type];
                }

                showDialog({
                    icon: null,
                    title: null,
                    html: `<div class="confirmation__text__box"> <h4 class="popup__title">Please Select Previous Test Item Before Scoring This Test Item.</h4> <div class="description__wrapper"> <p>It’s important to score each item sequentially. Please complete the previous item first.</p> </div> </div> `,
                    imageUrl: Icon
                });

                return;
            }
        }

        payload[type] = value;
        const { data } = await api.post(`/organizations/${props.organizationId}/assessments/${props.assessmentId}/attempt`, payload);
        item[type] = data.data[type];

        if (selectedAssessmentItem.value) {
            selectedAssessmentItem.value[type] = data.data[type];
            selectedAssessmentItem.value['audio'] = data.data['audio'];
            selectedAssessmentItem.value['consonant_score'] = data.data['consonant_score'];
            selectedAssessmentItem.value['no_response'] = data.data['no_response'];
            selectedAssessmentItem.value['start_time'] = data.data['start_time'];
            selectedAssessmentItem.value['end_time'] = data.data['end_time'];
        }

        lastUpdatedAttemptId.value = id;
    } catch (error) {
        console.log(error);
        item[type] = null;
        if(selectedAssessmentItem.value) {
            selectedAssessmentItem.value[type] = null;
        }
        resetRadios();
        emit('updated');
        handleError(error);
    } finally {
        loader.hide();
    }
};

// Record Audio Handler
const handleRecordAudio = async ({ item }) => {
    try {
        loader.show();
        const { data } = await api.get(`/organizations/${props.organizationId}/assessments/${props.assessmentId}/attempt/${item?.id}`);

        selectedAssessmentItem.value = data.data;

        const index = resultItems.value.findIndex(i => i.id === selectedAssessmentItem.value?.id);
        if (index === -1) return;

        resultItems.value[index] = data.data;
    } catch (error) {
        selectedAssessmentItem.value = null;
        handleError(error);
    } finally {
        loader.hide();
    }
};

// Update audio after save
const updateAudio = ({ id, value = null, extra = null }) => {
    startTranscriptionPolling(id);

    const index = resultItems.value.findIndex(i => i.id === id);
    if (index === -1) return;

    resultItems.value[index].audio = value;
    if (extra?.duration) {
        resultItems.value[index].duration = extra.duration;
    }

    if (extra?.start_time) {
        resultItems.value[index].start_time = extra.start_time;
    }

    if (extra?.end_time) {
        resultItems.value[index].end_time = extra.end_time;
    }

    if (extra?.transcription_status) {
        resultItems.value[index].transcription_status = extra.transcription_status;
    }
};

// Go to next group
const handleNavigate = (direction) => emit(`${direction}-group`);

// Go to next audio item
const handleAudioNav = ({ id, direction = 'next' }) => {

    const currentIndex = resultItems.value.findIndex(i => i.id === id);
    if (currentIndex === -1) return;

    const offset = direction === 'prev' ? -1 : 1;
    const targetIndex = currentIndex + offset;

    const item = resultItems.value[targetIndex];
    if (!item) {
        showDialog({
            icon: 'info',
            title: 'Info',
            html: `<p>You have reached the ${direction === 'next' ? 'last' : 'first'} item of Group ${currentGroup.value?.id}. 
                ${direction === 'next' && currentGroup.value?.id <=4 ? 'Moving to the next group.': 
                direction === 'next' && currentGroup.value?.id === 5 ? 'Moving to the Result' :
                currentGroup.value?.id > 1 ? 'Moving to the prev group' : ''}
                </p>`,
        });

        handleNavigate(direction);
        return;
    }

    handleRecordAudio({ item, index: targetIndex });
};

// Transcribe Handler
const openTranscribe = async ({ index }) => {
    emit('updated');

    const waitForLoader = () => {
        return new Promise((resolve) => {
            const interval = setInterval(() => {
                if (!loader.loading) {
                    clearInterval(interval);
                    resolve();
                }
            }, 100);
        });
    };

    await waitForLoader();

    resultItems.value.index = index;
    selectedAssessmentItem.value = resultItems.value[index - 1];
    showTranscribe.value = true;
};

const closeTranscribe = () => {
    selectedAssessmentItem.value = null;
    showTranscribe.value = false;
};

// Go to next Transcribe
const handleNextPrevTranscribe = async ({ id, direction = 'next' }) => {
    const index = resultItems.value.findIndex(i => i.attemptid === id);
    if (index === -1) return;

    emit('updated');

    const waitForLoader = () => {
        return new Promise((resolve) => {
            const interval = setInterval(() => {
                if (!loader.loading) {
                    clearInterval(interval);
                    resolve();
                }
            }, 100);
        });
    };

    await waitForLoader();

    const newIndex = direction === 'next' ? index + 1 : index - 1;
    const targetItem = resultItems.value[newIndex];

    if (!targetItem) {
        handleNavigate(direction);
        showTranscribe.value = false;
        closeTranscribe();
        return;
    }

    handleRecordAudio({ item: targetItem, index: newIndex });
    showTranscribe.value = true;
};

// Fetch questions on mount and when groupId changes
onMounted(fetchQuestions);
watch(() => props.groupId, (newVal) => newVal && fetchQuestions());

watch(flaggedCount, (newCount) => emit('update-flagged-count', {
    groupId: currentGroup.value?.id,
    count: newCount
}), { immediate: true });

watch(zeroScoreCount, (newCount) => emit('update-zero-count', {
    groupId: currentGroup.value?.id,
    count: newCount,
    lastUpdatedAttemptId: lastUpdatedAttemptId.value
}), { immediate: true });

const startTranscriptionPolling = (attemptId) => {
    pollAttemptApiUntilComplete(`/organizations/${props.organizationId}/assessments/${props.assessmentId}/attempt/${attemptId}`)
        .then((res) => {
            const index = resultItems.value.findIndex(i => i.id === attemptId);

            if (index === -1) return;

            resultItems.value[index].score = res.score;
            resultItems.value[index].transcription_status = res.transcription_status;
            resultItems.value[index].consonant_score = res.consonant_score;
            resultItems.value[index].transcribe_automated = res.transcribe_automated;

            if (selectedAssessmentItem.value?.id === attemptId) {
                selectedAssessmentItem.value.score = res.score;
                selectedAssessmentItem.value.transcription_status = res.transcription_status;
                selectedAssessmentItem.value.consonant_score = res.consonant_score;
                selectedAssessmentItem.value.transcribe_automated = res.transcribe_automated;
            }

            console.log("✅ Polling Done");
        })
        .catch((err) => {
            console.warn("⚠️ Polling stopped:", err.message);
        });
};

</script>
